export const GET_LOAN_DECISION = 'page/GET_LOAN_DECISION';
export const CANCEL_GET_LOAN_DECISION = 'page/CANCEL_GET_LOAN_DECISION';
export const LOAN_DECISION_ERROR = 'page/LOAN_DECISION_ERROR';

export const getLoanDecision = (payload) => ({
    type: GET_LOAN_DECISION,
    payload: payload
});
